import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardBody } from 'reactstrap';
import PageHeader from '../common/PageHeader';
import TablePageSizeSelect from '../common/TablePageSizeSelect';
import MedDataTable from '../common/MedDataTable';
import apiBase from '../../apiConfig';
import useStoredTablePageSize from '../../hooks/useStoredTablePageSize';

const Attendance = () => {
  const [logs, setLogs] = useState([]);
  const [pageSize, setPageSize] = useStoredTablePageSize();

  useEffect(() => {
    const fetchLogs = async () => {
      const res = await axios.get(`${apiBase}/attendance.php`, { params: { limit: 500 } });
      if (res.data.success) setLogs(res.data.logs);
    };

    fetchLogs().catch(console.error);
  }, []);

  const columns = [
    { dataField: 'full_name', text: 'F.I.O', sort: true, classes: 'align-middle font-weight-bold' },
    { dataField: 'login', text: 'Login', sort: true, classes: 'align-middle' },
    { dataField: 'user_type', text: 'Tip', sort: true, classes: 'align-middle' },
    { dataField: 'filial_name', text: 'Filial', sort: true, classes: 'align-middle', formatter: value => value || '-' },
    { dataField: 'login_at', text: 'Kirish vaqti', sort: true, classes: 'align-middle' },
    { dataField: 'ip_address', text: 'IP', sort: true, classes: 'align-middle' }
  ];

  return (
    <>
      <PageHeader title="Kirish tarixi" description="Foydalanuvchilarning tizimga kirish jurnali." className="mb-3" />
      <Card className="border-0 shadow-sm">
        <CardBody>
          <div className="d-flex justify-content-end mb-3">
            <TablePageSizeSelect value={pageSize} onChange={setPageSize} className="med-table-page-size" />
          </div>
          <MedDataTable
            data={logs}
            columns={columns}
            pageSize={pageSize}
            paginationResetKey="attendance"
            noDataIndication={<div className="text-center py-4 text-500">Kirish loglari topilmadi</div>}
            tableClasses="table table-hover fs--1 mb-0 med-dashboard-table"
          />
        </CardBody>
      </Card>
    </>
  );
};

export default Attendance;
